import {
  ChevronExpand,
  PlusCircleFill,
  Search,
  TrashFill,
} from "react-bootstrap-icons";
import ErrorDisplay from "../common/ErrorDisplay";
import LoadingDisplay from "../common/LoadingDisplay";
import { Form, InputGroup, Table } from "react-bootstrap";
import { BodyStyleModel, bodyStyleApi } from "../api/bodyStyleApi";
import { useEffect, useState } from "react";
import { Problem } from "../api/backendApi";
import { authUtils } from "../common/authUtils";
import { useAuth } from "react-oidc-context";
import BodyStyleModal from "../components/modals/BodyStyleModal";

function BodyStylesPage() {
  const auth = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [bodyStyles, setBodyStyles] = useState<BodyStyleModel[]>([]);
  const [error, setError] = useState<Problem | undefined>(undefined);
  const [filter, setFilter] = useState<string>("");
  const [sort, setSort] = useState<boolean>(false);
  const [isCreate, setIsCreate] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [newBodyStyle, setNewBodyStyle] = useState<BodyStyleModel | undefined>(
    undefined,
  );
  const [bodyStyleBeingEdited, setBodyStyleBeingEdited] = useState<
    BodyStyleModel | undefined
  >(undefined);
  const [filteredBodyStyles, setFilteredBodyStyles] = useState<
    BodyStyleModel[]
  >([]);

  const handleShow = (
    isCreate: boolean,
    modalText: string,
    bodyStyle?: BodyStyleModel,
  ) => {
    setModalText(modalText);
    setIsCreate(isCreate);
    setBodyStyleBeingEdited(bodyStyle);
    setNewBodyStyle(bodyStyle);
    setShow(true);
  };

  useEffect(() => {
    async function loadBodyStyles() {
      setLoading(true);
      const data = await bodyStyleApi.getBodyStyles();

      if (data.ok) {
        setError(undefined);
        setBodyStyles(data.value);
        setFilteredBodyStyles(data.value);
      } else {
        setError(data.problem);
      }

      setLoading(false);
    }
    loadBodyStyles();
  }, []);

  useEffect(() => {
    filterBodyStyles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, bodyStyles]);

  const filterBodyStyles = () => {
    var filteredBodyStyles = [...bodyStyles];

    filteredBodyStyles = filteredBodyStyles.filter(
      (bodyStyle) =>
        bodyStyle.english?.toUpperCase().includes(filter.toUpperCase()),
    );

    setFilteredBodyStyles(filteredBodyStyles);
  };

  const sortArray = (getter: any, order: boolean) => {
    const sortedArray = [...bodyStyles];
    sortedArray.sort((a, b) =>
      getter(a) !== undefined && getter(b) !== undefined
        ? order === true
          ? getter(a).localeCompare(getter(b))
          : getter(b).localeCompare(getter(a))
        : 0,
    );
    setBodyStyles(sortedArray);
  };

  const deleteBodyStyle = (bodyStyle: BodyStyleModel) => {
    bodyStyleApi.deleteBodyStyles(bodyStyle.style).then((response) => {
      if (response.ok) {
        setBodyStyles(bodyStyles.filter((b) => b !== bodyStyle));
      } else {
        setError(response.problem);
      }
    });
  };

  const onNewBodyStyle = (bodystyle: BodyStyleModel) => {
    setBodyStyles([...bodyStyles, bodystyle]);

    setNewBodyStyle(undefined);

    setTimeout(() => {
      var scrollingElement = document.querySelector("div.fixed-table-header");
      scrollingElement?.scrollTo(0, scrollingElement?.scrollHeight);
    }, 50);
  };

  const onBodyStyleChanged = (bodyStyle: BodyStyleModel) => {
    setError(undefined);
    let updatedBodyStyle = bodyStyles.map((b: BodyStyleModel) => {
      return b === bodyStyleBeingEdited ? bodyStyle : b;
    });

    setBodyStyles(updatedBodyStyle);
    filterBodyStyles();
    setBodyStyleBeingEdited(undefined);
  };

  return (
    <>
      <div className="main-container-title">
        <h1
          style={{
            alignItems: "center",
            justifyContent: "left",
            display: "flex",
          }}
        >
          Vehicle Body Styles
          <PlusCircleFill
            className="text-primary"
            onClick={() => handleShow(true, "Add Body Style", undefined)}
            width={32}
            height={32}
            style={{ marginLeft: "0.5rem" }}
            role="button"
          />
        </h1>
        <ErrorDisplay error={error} />
      </div>
      <div className="main-container-content">
        <LoadingDisplay loading={loading} />
        {!loading && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <InputGroup
              className="sm mb-2 mt-1"
              style={{
                display: "flex",
                width: "fit-content",
                marginRight: "1rem",
              }}
            >
              <span
                className="input-group-text"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <Search width={12} height={12} />
                <Form.Label
                  style={{
                    fontWeight: "400",
                    fontSize: "16px",
                    display: "flex",
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginLeft: "5px",
                  }}
                >
                  Filter
                </Form.Label>
              </span>
              <Form.Control
                size="sm"
                onChange={(e) => {
                  setFilter(e.target.value);
                }}
                style={{ width: "400px" }}
              ></Form.Control>
            </InputGroup>
          </div>
        )}
        {!loading && (
          <div
            className="shadow p-3 bg-white rounded"
            style={{ height: "95%" }}
          >
            <div className="fixed-table-header" style={{ height: "100%" }}>
              <Table hover striped>
                <thead>
                  <tr>
                    <th>
                      <Form.Label
                        style={{
                          marginRight: "1rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          sortArray((b: BodyStyleModel) => b.style, sort);
                          setSort(!sort);
                        }}
                        className="table-header"
                      >
                        Style
                        <ChevronExpand
                          className="text-primary"
                          style={{
                            display: "flex",
                            margin: "1px",
                            borderLeft: "1px solid #0d6efd",
                            marginLeft: "5px",
                          }}
                        />
                      </Form.Label>
                    </th>
                    <th>
                      <Form.Label
                        style={{
                          marginRight: "1rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          sortArray((b: BodyStyleModel) => b.english, sort);
                          setSort(!sort);
                        }}
                        className="table-header"
                      >
                        English
                        <ChevronExpand
                          className="text-primary"
                          style={{
                            display: "flex",
                            margin: "1px",
                            borderLeft: "1px solid #0d6efd",
                            marginLeft: "5px",
                          }}
                        />
                      </Form.Label>
                    </th>
                    <th style={{ width: "1px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredBodyStyles.map((bodyStyle, index) => (
                    <tr
                      className="table-row-scale"
                      role="button"
                      key={index}
                      onClick={() =>
                        handleShow(false, "Edit Body Style", bodyStyle)
                      }
                    >
                      <td>{bodyStyle.style}</td>
                      <td>{bodyStyle.english}</td>
                      <td>
                        <TrashFill
                          className="text-danger"
                          height={24}
                          width={24}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (
                              window.confirm(
                                "Are you sure this body style can be deleted?",
                              )
                            ) {
                              deleteBodyStyle(bodyStyle);
                            }
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>
      {show && authUtils.isUser(auth) ? (
        <BodyStyleModal
          bodyStyle={
            newBodyStyle ?? {
              style: undefined,
              english: undefined,
              dutch: undefined,
              german: undefined,
              french: undefined,
              spanish: undefined,
              portugues: undefined,
              italian: undefined,
              polish: undefined,
              czech: undefined,
              swedish: undefined,
              danish: undefined,
              norwegian: undefined,
              finnish: undefined,
              hungarian: undefined,
              croatian: undefined,
              hebrew: undefined,
              slovene: undefined,
              russian: undefined,
              arabic: undefined,
              ukrainian: undefined,
            }
          }
          isCreate={isCreate}
          onChange={isCreate ? onNewBodyStyle : onBodyStyleChanged}
          onCancel={() => {
            setShow(false);
            setNewBodyStyle(undefined);
          }}
          modalText={modalText}
        />
      ) : null}
    </>
  );
}

export default BodyStylesPage;
